import React, { Component } from "react";
import Constants from "./Constants";
import Header from "./Header";
import Navbar from "./Navbar";
import { Helmet } from "react-helmet";

import Footer from "./Footer";
import { Link } from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";
import Axios from "axios";
import NewConstants from "./NewConstants";

export default class Batches extends Component {
  state = {
    batches: [],
    specification: {},
    data: "",
    metaTitle: "",
    metaDescription: "",
    imgText: "",
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    // this.getbatches();
    let id = this.props.match.params.id;
    let data = this.props.location.state.name;

    // console.log(this.props);
    Axios.post(NewConstants.postUrls.courseBatchesByLevelId, {
      level_id: id,
    }).then((res) => {
      console.log(res.data.data, "--bathces");
      this.setState({
        batches: res.data.data.batches,
        data,
        metaTitle: res.data.data.meta_key,
        metaDescription: res.data.data.meta_description,
        imgText: res.data.data.img_alt_text,
      });
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      // alert("some");
      let id = this.props.match.params.id;
      let data = this.props.location.state.name;

      Axios.post(NewConstants.postUrls.courseBatchesByLevelId, {
        level_id: id,
      }).then((res) => {
        // console.log(res.data);
        this.setState({
          batches: res.data.data.batches,
          data,
        });
      });
    }
  }
  openModal(id) {
    // console.log(name);

    this.setState(
      {
        // visible : true,
        specification: this.state.batches.find((element) => element.id === id),
      },
      () => {
        console.log(this.state.specification);
      },
    );
  }

  closeModal() {
    this.setState({
      visible: false,
    });
  }
  render() {
    return (
      <div>
        <Helmet>
          <link
            rel="canonical"
            href={`https://www.vpaedu.com/batches/${
              this.props.match &&
              this.props.match.params &&
              this.props.match.params.id
                ? this.props.match.params.id
                : ""
            }`}
          />
          <title>
            {this.state.metaTitle !== "" &&
            this.state.metaTitle !== null &&
            this.state.metaTitle !== undefined
              ? this.state.metaTitle
              : this.state.data.label === "CA"
              ? "Trusted CA Coaching in Nagpur – VPA Edu"
              : this.state.data.label === "CS"
              ? "Top CS Coaching Institute in Nagpur – VPA Edu"
              : this.state.data.label === "XI-XII CBSE"
              ? "VPA Edu | Leading 11th-12th CBSE Commerce Classes in Nagpur"
              : this.state.data.label === "XI-XII State Board"
              ? "VPA Edu | Leading 11th-12th State Board Commerce Classes in Nagpur"
              : "11th-12th State Board Commerce Classes in Nagpur – VPA Edu"}
          </title>
          <meta
            name="description"
            content={
              this.state.metaDescription !== "" &&
              this.state.metaDescription !== null &&
              this.state.metaDescription !== undefined
                ? this.state.metaDescription
                : this.state.data.label === "CA"
                ? "Crack CA Foundation, CA Intermediate and CA Final with VPA Edu in Nagpur. Expert faculty, updated syllabus, study material, test series. Join now!"
                : this.state.data.label === "CS"
                ? "Start your CS-EET, CS Executive and CS Professional preparation at VPA Edu Nagpur with expert guidance, study material and test series. Enroll now!"
                : this.state.data.label === "XI-XII CBSE"
                ? "Excel in Std. 11th 12th CBSE Commerce with VPA Edu. Expert teaching in Accountancy, Mathematics, Business Studies, Economics, and English."
                : this.state.data.label === "XI-XII State Board"
                ? "VPA Edu offers expert 11th–12th State Board Commerce Classes in Nagpur for Accountancy, Maths, Economics, Secretarial Practices, OCM and English."
                : "VPA Edu offers expert 11th–12th State Board Commerce Classes in Nagpur for Accountancy, Maths, Economics, Secretarial Practices, OCM and English."
            }
          />
        </Helmet>
        <Header />
        <Navbar />
        <div className="breadcumb-area bg-img" style={{ position: "relative" }}>
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/7/77/Medlibrary.jpg"
            alt={
              this.state.imgText != "" &&
              this.state.imgText != null &&
              this.state.imgText != undefined
                ? this.state.imgText
                : "Students studying together in a busy library reading room."
            }
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 0,
            }}
          />
          <div className="bradcumbContent">
            <h2>Batches</h2>
          </div>
        </div>
        {/* <ScrollAnimation
          animateIn="fadeInUp"
          animateOnce={true}
          animationInDuration={1800}
          isVisible={true}
        > */}
        <section className="ftco-section">
          {/* <h5
              style={{
                textAlign: "center",
                marginBottom: "40px",
                fontWeight: "bold",
                fontSize: "25px"
              }}
            >
              {this.state.data.label ? this.state.data.label : null}
            </h5> */}

          <div className="container-fluid px-4">
            <div className="row">
              {/* <h3>{this.state.data.label.name} </h3> */}

              {this.state.batches.map((singleCourse) => (
                <div
                  data-aos="zoom-in"
                  className="col-md-3 course "
                  style={{ marginBbottom: "60px", height: "450px" }}
                >
                  <div
                    className="single-top-popular-course"
                    style={{ padding: "15px" }}
                  >
                    <div className="img">
                      <img
                        alt={
                          singleCourse.img_alt_text
                            ? singleCourse.img_alt_text
                            : this.state.data.label === "CA"
                            ? "Chartered Accountancy (CA) course overview with CA logo and exam details."
                            : this.state.data.label === "CS"
                            ? "Company Secretary (CS) course overview with CS logo and exam details."
                            : this.state.data.label === "XI-XII CBSE"
                            ? "Banner introducing Std. XI–XII CBSE Commerce classes"
                            : this.state.data.label === "XI-XII State Board"
                            ? "Banner introducing Std. XI–XII Maharashtra State Board Commerce classes"
                            : singleCourse.batch_name || "Batch image"
                        }
                        src={NewConstants.imageUrl + singleCourse.image_path}
                        width="100%"
                      />
                    </div>
                    <div className="text pt-4">
                      <h3>{singleCourse.batch_name}</h3>
                      <p>
                        {singleCourse.description
                          ? singleCourse.description
                          : "Description not available"}
                      </p>
                      <p>
                        {/* <b>Batch Tim :</b> {singleCourse.batch_time} */}
                      </p>
                      <section>
                        <Link
                          to={{
                            pathname: "/batchDetail",
                            state: {
                              name: singleCourse.batch_name,
                              specification: singleCourse.specification,
                              batchtime: singleCourse.batch_time,
                              id: singleCourse.id,
                              file: singleCourse.file_path,
                              meta_key: singleCourse.meta_key,
                              meta_description: singleCourse.meta_description,
                              img_alt_text: singleCourse.img_alt_text,
                            },
                          }}
                          className="btn download_btn"
                          onClick={() => this.openModal(singleCourse.id)}
                          style={{
                            padding: "12px",
                            fontWeight: "600",
                            color: "white",
                            margin: "0 40px",
                          }}
                        >
                          View / DownLoad
                        </Link>
                      </section>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        {/* </ScrollAnimation> */}

        <Footer />
      </div>
    );
  }
}
